type Props = {
  src: string;
  alt: string;
  className?: string;
};

/** A plain CSS phone frame around a screenshot. No extra assets, sized by its parent's width. */
export function PhoneMockup({ src, alt, className = "" }: Props) {
  return (
    <div className={`relative mx-auto w-full max-w-[220px] ${className}`}>
      {/* side buttons */}
      <span aria-hidden className="absolute -left-[2px] top-[18%] h-8 w-[3px] rounded-l bg-black/80" />
      <span aria-hidden className="absolute -left-[2px] top-[28%] h-12 w-[3px] rounded-l bg-black/80" />
      <span aria-hidden className="absolute -right-[2px] top-[24%] h-16 w-[3px] rounded-r bg-black/80" />
      <div className="rounded-[2rem] bg-black p-[6px] ring-1 ring-border shadow-lg">
        <div className="relative overflow-hidden rounded-[1.65rem] bg-background" style={{ aspectRatio: "400 / 813" }}>
          <img
            src={src}
            alt={alt}
            width={400}
            height={813}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-top"
          />
          <span aria-hidden className="absolute left-1/2 top-2 h-[14px] w-[14px] -translate-x-1/2 rounded-full bg-black" />
        </div>
      </div>
    </div>
  );
}
